import { isMultilingual } from '../../../languages';

export const typeFormPartnersLink = isMultilingual
  ? 'https://tillifrance.typeform.com/to/acdXCR01'
  : 'https://tillifrance.typeform.com/to/F0xl01hP';
